// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    apiPath: "/api/",
    firebase: {
        apiKey: "AIzaSyCw2TiCba0ABPz09yq-cFwZKjUw0uVjUZI",
        authDomain: "bdo-system.firebaseapp.com",
        databaseURL: "https://bdo-system.firebaseio.com",
        projectId: "bdo-system",
        storageBucket: "bdo-system.appspot.com",
        messagingSenderId: "1051695728631",
        appId: "1:1051695728631:web:637b5ebab09c9d6a8210f2"
    }
};
